import {Tooltip} from '@mui/material'
import {Box, Loading, Skeleton, Typography} from '@viptech/react-components'
import Progressbar from 'src/components/Progressbar'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'
import {abbreviateNumber} from 'src/utilities/formatter'
import {calculatePercent} from '../default-dashboard/functions'

type Item = {
  name: string
  value: number
  color: string
}

type Props = {
  title: string
  loading: boolean
  total: number
  description: string
  data: Array<Item>
  refetching?: boolean
}

export default function DashboardLprCard({title, total, refetching, description, data, loading}: Props) {
  const {styledTheme} = usePersonalizedThemeByCompany()
  return (
    <Box backgroundColor='white' position='relative' borderRadius='16px' width='100%' height='320px' style={{boxShadow: '0px 5px 8px 0px #00000026'}}>
      <Box display='flex' direction='column' padding='24px' rowGap='6px' align='center'>
        <Typography variant='label' size='16px' marginTop='8px' color={styledTheme.dashboard.colors.title} weight={600}>
          {title}
        </Typography>
        {refetching && !loading && (
          <Tooltip title='Buscando atualizações' placement='top'>
            <Box position='absolute' right='24px' display='flex' columnGap='8px'>
              <Loading size='20px' />
            </Box>
          </Tooltip>
        )}

        <Box display='flex' direction='column' align='center' marginTop='12px'>
          {loading ? (
            <Skeleton width='72px' height='56px' borderRadius='8px' />
          ) : (
            <Typography variant='label' size='56px' color='#344054' lineHeight='56px' weight={700}>
              {abbreviateNumber(total)}
            </Typography>
          )}

          <Typography variant='label' color='#667085' size='12px'>
            {description}
          </Typography>
        </Box>

        <Box display='flex' width='100%' direction='column' rowGap='24px' marginTop='12px'>
          <Box display='flex' width='100%' direction='column' rowGap='24px' marginTop='12px'>
            {data.map((item, index) => (
              <Box display='flex' direction='column' rowGap='6px' key={index}>
                <Box display='flex' justify='space-between' width='100%'>
                  <Typography variant='label' size='14px' weight={700}>
                    {item.name}
                  </Typography>
                  {loading ? (
                    <Skeleton width='24px' height='14px' borderRadius='8px' />
                  ) : (
                    <Typography color={item.color} variant='label' size='14px' weight={700}>
                      {calculatePercent(item.value, total).toFixed(0)}%
                    </Typography>
                  )}
                </Box>
                {loading ? (
                  <Box height='10px' width='100%'>
                    <Skeleton width='100%' height='10px' borderRadius='8px' />
                  </Box>
                ) : (
                  <Progressbar showPercentage={false} percentage={calculatePercent(item.value, total)} color={item.color} />
                )}
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
